import { useCallback, useState } from "react";
import { errorMessage, syncPendingProducts } from "../services/blingService";

const MAX_BATCHES = 100;

// Envia ao Bling, em lotes, os produtos novos/alterados até não sobrar nenhum.
export function useBlingProductSync() {
  const [syncing, setSyncing] = useState(false);
  const [synced, setSynced] = useState(0);
  const [remaining, setRemaining] = useState(null);
  const [errors, setErrors] = useState([]);

  const start = useCallback(async () => {
    setSyncing(true);
    setSynced(0);
    setErrors([]);
    try {
      for (let batch = 0; batch < MAX_BATCHES; batch++) {
        const result = await syncPendingProducts();
        setSynced((n) => n + (result.results?.length || 0));
        setErrors((prev) => [...prev, ...(result.errors || [])]);
        setRemaining(result.remaining);
        if (
          !result.remaining ||
          !(result.results?.length || result.errors?.length)
        )
          break;
      }
    } catch (err) {
      setErrors((prev) => [...prev, { code: "—", error: errorMessage(err) }]);
    } finally {
      setSyncing(false);
    }
  }, []);

  return { syncing, synced, remaining, errors, start };
}
